<template>
  <div class="doorderlogin doorder-auth-container doorder-auth-bg-container">
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div class="col-xl-4 col-lg-6 col-md-9 col-sm-12 mx-auto my-auto">
          <Login
            titleH2=""
            welcomeHeader="Welcome to DoOrder!"
            welcomeSubheader="Please sign-in to your account and start the adventure"
            logoSrc="doorder/Logo.png"
            guard="DOORDER"
            clientLink="doorder"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/auth/Login";

export default {
  name: "DoorderLogin",
  components: { Login },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onSubmit() {
      console.log("submit login");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/doorder-styles.css";
@import "../css/doorder-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doorder/auth/LoginView.vue